import React, { Component, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import './style.scss';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
function StateSelector({
  loading, onChange, disabled, showError, title, hideTitle, containerClassName, inputClassName, labelClassName, customStyle, selectedState, placeholder, showAll, includedStates, isMultiple, noDropdownAlign, showSearch, allowClear,
}) {
  const [searchKeyword, setSearchKeyword] = useState('');
  const states = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chattisgarh', 'Delhi', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Lakshadweep Islands', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Pondicherry', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra & Nagar Haveli and Daman & Diu', 'Ladakh', 'Other Territory'];

  return (
    <div className={`state-selector__wrapper ${containerClassName}`}>
      {!hideTitle ? (
        <label className={labelClassName || 'orgFormLabel'}>
          {title || 'State'}
          <span style={{ color: 'red' }}>{'  *'}</span>
        </label>
      ) : <React.Fragment /> }
      <PRZSelect
        mode={isMultiple ? 'multiple' : ''}
        value={selectedState}
        filterOption={false}
        disabled={disabled}
        placeholder={placeholder}
        allowClear={allowClear}
        onChange={(value) => {
          if (isMultiple) {
            const stateNameArr = [];
            for (let i = 0; i < value?.length; i++) {
              stateNameArr.push(value[i]);
            }
            onChange(stateNameArr);
          } else {
            onChange(value);
          }
        }}
        style={customStyle}
        className={inputClassName || ' input'}
        showSearch={showSearch}
        onSearch={(value) => setSearchKeyword(value)}
        loading={loading}
        maxTagCount="responsive"
      >
        {states
          ?.filter((item) => item?.toLowerCase().includes(searchKeyword?.toLowerCase()))
          ?.map((state) => (
            <Option key={state} value={state}>
              {state}
            </Option>
          ))}
      </PRZSelect>
      {showError && (
        <div className="input-error">
          *Please select state
        </div>
      )}
    </div>

  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
});

StateSelector.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClassName: PropTypes.any,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  customStyle: PropTypes.any,
  selectedState: PropTypes.any,
  showAll: PropTypes.bool,
  includedStates: PropTypes.any,
  isMultiple: PropTypes.bool,
  noDropdownAlign: PropTypes.any,
  showSearch: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StateSelector));
